import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    directorId: string;
    userIds: string[];
};

export const schemaUserResolver_AreUsersInCorporation = z.boolean();

export type SchemaUserResolver_AreUsersInCorporation = z.infer<typeof schemaUserResolver_AreUsersInCorporation>;

export type UserResolver_AreUsersInCorporation = Resolver<Arguments, SchemaUserResolver_AreUsersInCorporation>;
